import { Step } from "react-joyride";

/**
 * Guided tour steps for the Revisions step (RFx Lead view).
 *
 * Each step targets a `data-testid` attribute rendered in the step.
 * If a target isn't present, Joyride will auto-skip it.
 */
export const revisionsLeadSteps: Step[] = [
	{
		target: '[data-testid="tab-revision-requests"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Revision Requests</h3>
				<p>
					View and manage revision requests sent to suppliers. You can create
					new requests asking suppliers to update their submission documents.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="tab-revision-uploads"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Revision Uploads</h3>
				<p>
					Switch to this tab to view documents uploaded by suppliers in response
					to revision requests. These updated documents will be available during
					final scoring.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
];

/**
 * Guided tour steps for the Revisions step (Panel Member view).
 */
export const revisionsMemberSteps: Step[] = [
	{
		target: '[data-testid="panel-revisions-view"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Revision Requests</h3>
				<p>
					View revision requests raised by the RFx Lead. Once suppliers upload
					revised documents, they will appear here for your review before
					final scoring.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
];
